import React, { useEffect, useState } from 'react';
import { getFieldList, getHospitalList, manuallyRegisterUser } from '../../services/user.service';
import { Button, makeStyles, TextField, Typography, Grid, Select, MenuItem, InputLabel, Switch, FormControlLabel, CircularProgress } from '@material-ui/core';
import Dialog from '../ui/Dialog';
import LoadingOverlay from '../LoadingOverlay/LoadingOverlay.component';
import { includes } from 'lodash';
import { upload } from '../../services/storage.service';

const AddHCPAction = ({ data }) => { 
  const [openModal, setOpenModal] = useState(false);
  const [openConfirmation, setConfirmation] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [errorInputMessage, setErrorInputMessage] = useState(null);
  const [fileToUpload, setFileToUpload] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState(null);

  const useStyles = makeStyles((theme) => ({
    field: {
        marginBottom: 10,
        width: '100%',
    },
    select: {
        width: '100%'
    },
    formControl: {
        width: '100%'
    },
    fileInput: {
        display: 'none',
    },
    fileName: {
        marginLeft: theme.spacing(2),
        fontWeight: 500,
    },
    uploadStatus: {
        marginLeft: theme.spacing(2),
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    errorText: {
        color: theme.palette.error.main,
        marginTop: theme.spacing(1),
    }
  }));

  const classes = useStyles();

  const { user_type, mobile_number, first_name, middle_name, last_name, email } = data;
  const [userDetails, setUserDetails] = useState({
    mobile_number,
    first_name, 
    middle_name, 
    last_name, 
    email,
    user_type,
  });
  const [listOfDispensingChannel, setListOfDispensingChannel] = useState();
  const [listOfHospital, setListOfHospital] = useState();
  const { match } = data;
  const program_id = match.params.connect_program_id;
  let nodeEnv = 'develop';
  if (program_id) {
    const splittedProgramId = program_id.split('-');
    if (splittedProgramId && splittedProgramId.length) {
      nodeEnv = splittedProgramId.pop();
    }
  }
  const programId = includes(program_id, 'lets-get-started-fraizeron') ? `one-novartis-${nodeEnv}` : program_id;
  const [showAZControls, setShowAZControls] = useState( includes(programId, 'az-id') ? true : false );
  useEffect(() => {
		const getHospitals = async () => {
			const { result } = await getHospitalList(programId, true);

      if (result) {
        setListOfHospital(result);
      }
		}

			getHospitals();
	}, []);

  useEffect(() => {
    const getAllDispensingChannel = async () => {
      const { result } = await getFieldList({
        program_id: programId,
        name: 'outlet_name'
      });

      let dispensingChannel = [];

      if (result && result.field_type_options) {
        dispensingChannel = result.field_type_options.select_options;
      }

      dispensingChannel.unshift({ label: 'NA', value: 'NA' });

      setListOfDispensingChannel(dispensingChannel);
    }

    const getAllHospital = async () => {
      const { result } = await getFieldList({
        program_id: programId,
        name: 'hospital'
      });

      let hospitals = [];

      if (result && result.field_type_options) {
        hospitals = result.field_type_options.select_options;
      }

      hospitals.unshift({ label: 'NA', value: 'NA' });

      setListOfHospital(hospitals);
    }

    getAllDispensingChannel();
    getAllHospital();
  }, []);

  const onClick = async () => {
    setOpenModal(true);
  };

  const onSubmit = async() => {
    try {
      setLoading(true);
      const metadata = showAZControls
        ? {
          hospital: userDetails.hospital? userDetails.hospital.split(";").map(h => h.trim()): [], 
          license_number: userDetails.license,
        }
        : {
          hospital: userDetails.hospital,
          outlet_name: userDetails.outlet_name,
          doctor_consent_document: fileToUpload?.url || undefined,
        };

      const { result } = await manuallyRegisterUser({
        program_id: programId,
        payload: {
          user_type: showAZControls? 'doctor' : userDetails.user_type,
          mobile_number: userDetails.mobile_number,
          email: userDetails.email,
          first_name: userDetails.first_name,
          last_name: userDetails.last_name,
          middle_name: userDetails.middle_name,
          full_name: `${userDetails.first_name} ${userDetails.middle_name} ${userDetails.last_name}`,
          metadata: metadata,
          email_verified_at: new Date(),
          send_update_password_email: true,
        }
      });

      if (result) {
        setOpenModal(false);
        setConfirmation(true);
      } else {
        setUserDetails({
          mobile_number,
          first_name, 
          middle_name, 
          last_name, 
          email,
          user_type,
        });
      }
    } catch(err) {
      if (err && err.inputs) {
        setErrorInputMessage(err.inputs);
      } else if (err && err.message) {
        alert(err.message);
      }
    } finally {
      setLoading(false);
    }
  }

  const onFieldInput = (e) => {
    const { name, value } = e.target;

    setUserDetails(prevState => ({
      ...prevState,
      [name]: value,
    }));
  }

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploadError(null);
    setIsUploading(true);

    try {
        const { result } = await upload(file, programId);

        if (!result?.url) {
            throw new Error('Upload failed - no URL returned');
        }
        setFileToUpload({ file, url: result.url });
    } catch (error) {
        console.error('Upload failed:', error);
        setUploadError(error.message || 'File upload failed');
    } finally {
        setIsUploading(false);
    }
  };

  const formContent = (
    <>
      <Grid
        item
        container
        xs={12}
        spacing={2}
      >
        <Grid item xs={12}>
            <TextField  
              label='Mobile Number'
              required={true}
              name='mobile_number' 
              defaultValue={userDetails.mobile_number}
              variant='outlined'
              className={classes.field}
              onChange={onFieldInput} 
              placeholder='60XXXXXXXXX'
            />
            <Typography
              variant='caption'
              display='block'
              gutterBottom
              color='error'
            >
              { errorInputMessage ? errorInputMessage.mobile_number : '' }
            </Typography>
        </Grid>
      </Grid>
      <Grid
        item
        container
        xs={12}
        spacing={2}
      >
        <Grid item xs={6}>
          <TextField 
            required={true}
            label='First Name'
            name='first_name' 
            defaultValue={userDetails.first_name}
            variant='outlined'
            className={classes.field}
            onChange={onFieldInput}
            />
          <Typography
            variant='caption'
            display='block'
            gutterBottom
            color='error'
          >
          { errorInputMessage ? errorInputMessage.first_name : '' }
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <TextField 
            required={true}
            label='Last Name'
            name='last_name' 
            defaultValue={userDetails.last_name}
            variant='outlined'
            className={classes.field}
            onChange={onFieldInput}
            />
          <Typography
            variant='caption'
            display='block'
            gutterBottom
            color='error'
            >
            { errorInputMessage ? errorInputMessage.last_name : '' }
          </Typography>
        </Grid>
      </Grid>
      <Grid
        item
        container
        xs={12}
        spacing={2}
      >
         <Grid 
          item xs={12}
        >
          <TextField  
            label='Email Address'
            name='email' 
            defaultValue={userDetails.email}
            variant='outlined'
            className={classes.field}
            onChange={onFieldInput}
          />
          <Typography
            variant='caption'
            display='block'
            gutterBottom
            color='error'
            >
            { errorInputMessage ? errorInputMessage.email : '' }
          </Typography>
        </Grid>
      </Grid>

    {showAZControls && (
      <Grid
        item
        container
        xs={12}
        spacing={2}
      >
        <Grid item xs={6}>
           <TextField  
            label='Hospital'
            name='hospital' 
            defaultValue={userDetails.hospital}
            variant='outlined'
            className={classes.field}
            onChange={onFieldInput}
          />
          <Typography
            variant='caption'
            display='block'
            gutterBottom
            color='error'
            >
            { errorInputMessage ? errorInputMessage.email : '' }
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <TextField  
            label='Doctor’s License/STR'
            name='license' 
            defaultValue={userDetails.license}
            variant='outlined'
            className={classes.field}
            onChange={onFieldInput}
          />
          <Typography
            variant='caption'
            display='block'
            gutterBottom
            color='error'
            >
            { errorInputMessage ? errorInputMessage.license : '' }
          </Typography>
        </Grid>
      </Grid>
      )}

      {!showAZControls && (
      <Grid
        item
        container
        xs={12}
        spacing={2}
      >
        <Grid item xs={6}>
          <InputLabel>Hospital</InputLabel>
          <Select
            required={true}
            label='Hospital'
            name="hospital"
            variant='outlined' 
            className={classes.field}
            onChange={onFieldInput}
          >
             {
                listOfHospital && listOfHospital.length ? listOfHospital.map(hospital => {
                  return <MenuItem className={classes.menuItem} key={hospital.value} value={hospital.value}>
                  {hospital.label}
                </MenuItem>
                }) : <></>
              }
            </Select>
        </Grid>
        <Grid item xs={6}>
          <InputLabel>Outlet Name</InputLabel>
          <Select 
              required={true}
              label='Outlet Name'
              name="outlet_name"
              variant='outlined' 
              className={classes.field}
              onChange={onFieldInput}
            >
              {
                listOfDispensingChannel && listOfDispensingChannel.length ? listOfDispensingChannel.map(dispensingChannel => {
                  return <MenuItem className={classes.menuItem} key={dispensingChannel.value} value={dispensingChannel.value}>
                  {dispensingChannel.label}
                </MenuItem>
                }) : <></>
              }
            </Select>
        </Grid>
      </Grid>
      )}

      {!showAZControls && (
      <Grid
        item
        container
        xs={12}
        spacing={2}
      >
         <Grid item xs={6}>
            <InputLabel>User Type</InputLabel>
            <Select 
              required={true}
              label='User Type'
              name="user_type"
              variant='outlined' 
              className={classes.field}
              onChange={onFieldInput}
            >
                <MenuItem className={classes.menuItem} key="doctor" value="doctor">
                  Doctor
                </MenuItem>
                <MenuItem className={classes.menuItem} key="pharmacist" value="pharmacist">
                  Pharmacist
                </MenuItem>
            </Select>
            <Typography
              variant='caption'
              display='block'
              gutterBottom
              color='error'
            >
              { errorInputMessage ? errorInputMessage.user_type : '' }
            </Typography>
        </Grid>
        <Grid
          item
          container
          xs={12}
          spacing={2}
        >
          <Grid item xs={12}>
            <InputLabel>Doctor Consent Document</InputLabel><br />
            <div>
              <input
                  accept="*"
                  className={classes.fileInput}
                  id="file-upload"
                  type="file"
                  onChange={handleFileChange}
                  disabled={isUploading}
              />
              <label htmlFor="file-upload">
                  <Button
                      variant="contained"
                      component="span"
                      color="primary"
                      disabled={isUploading}
                      startIcon={isUploading ? <CircularProgress size={20} /> : null}
                  >
                      {isUploading ? 'Uploading...' : 
                      (fileToUpload?.file.name ? 'Change File' : 'Upload File')}
                  </Button>
              </label>
              <div className={classes.uploadStatus}>
                  <Typography className={classes.fileName}>
                      {fileToUpload?.file.name || 'No file selected'}
                  </Typography>
              </div>
              {uploadError && (
                  <Typography className={classes.errorText}>
                      {uploadError}
                  </Typography>
              )}
              {errorInputMessage?.url && (
                  <Typography variant='caption' display='block' gutterBottom color='error'>
                      {errorInputMessage.url}
                  </Typography>
              )}
            </div>
          </Grid>
        </Grid>
      </Grid>
      )}
   
      <Typography
        variant='caption'
        display='block'
        gutterBottom
        color='error'
      >
        { errorMessage }
      </Typography>
    </>
  );

  const handleClose = (reload) => {
    setOpenModal(false);
    setConfirmation(false);
    setErrorMessage(null);
    setUserDetails({
      mobile_number,
      first_name, 
      middle_name, 
      last_name, 
      email,
      user_type,
    });

    if (reload) {
      window.location.reload();
    }
  }

  const formButtons = (
    <>
      <Button onClick={() => handleClose(false)} variant='contained'>
        Close
      </Button>
      <Button onClick={onSubmit} variant='contained' color='secondary'>
        Submit
      </Button>
    </>
  );

  if (isLoading) {
    return <LoadingOverlay />;
  }

  return (
    <>
     <Dialog
      key='create-hcp'
      open={openModal}
      title = 'Create HCP'
      content = {formContent} 
      children = {formButtons} 
      onSubmit = {onSubmit}
      onClose = {() => handleClose(false)} 
      />
     <Dialog 
      key='confirmation'
      open={openConfirmation}
      title = 'Confirmation'
      content = 'HCP successfully created!' 
      children = {(
        <Button onClick={() => handleClose(true)} variant='contained'>
          Close
        </Button>
      )} 
      onSubmit = {onSubmit}
      onClose = {() => handleClose(true)} 
      />
     <Button variant="contained" color="primary" onClick={onClick} 
     style={{ marginRight: 8 }}>
      + ADD HCP</Button>
    </>
  )
}

export default AddHCPAction;
